import type * as api from '@gitbook/api-client';

import type { ContentInstallationContext } from '../types';

/**
 * Determines if gitbook can know the status of the configuration.
 * Configuration is "knowable" if it uses "properties" (vs "componentId")
 */
export function isConfigurationStatusKnowable(
    integration: api.Integration,
    contentInstallationContext?: ContentInstallationContext
): boolean {
    const orgConfigurationDefinition = integration.configurations?.account;
    const contentConfigurationDefinition = contentInstallationContext
        ? integration.configurations?.[contentInstallationContext.type]
        : undefined;

    return Boolean(
        (orgConfigurationDefinition && 'properties' in orgConfigurationDefinition) ||
            (contentConfigurationDefinition && 'properties' in contentConfigurationDefinition)
    );
}
